(function () {
  function parseMoney(text) {
    if (!text) return null;
    const cleaned = text.replace(/,/g, '');
    const match = cleaned.match(/[$€£]\s*([0-9]+(?:\.[0-9]{1,2})?)/);
    return match ? parseFloat(match[1]) : null;
  }

  function getQty(scope) {
    const input = scope.querySelector('input[name="quantity"]');
    if (!input) return 1;
    const qty = parseInt(input.value, 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getBundleTotalPrice(scope) {
    const selectedBundle =
      scope.querySelector('[aria-checked="true"] .volume-discount-price') ||
      scope.querySelector('.ab-volume-discount-item.active .volume-discount-price') ||
      scope.querySelector('.ab-volume-discount-item-discount-price .volume-discount-price') ||
      scope.querySelector('.volume-discount-price');

    if (!selectedBundle) return null;
    return parseMoney(selectedBundle.textContent);
  }

  function getSubscriptionPrice(scope) {
    const checked = scope.querySelector('input[name="selling_plan"]:checked');
    if (!checked) return null;

    const label = scope.querySelector(`label[for="${checked.id}"]`);
    if (!label) return null;

    const nodes = label.querySelectorAll('*');
    for (const node of nodes) {
      if (node.querySelector && node.querySelector('s, del')) continue;
      const val = parseMoney(node.textContent);
      if (val !== null) return val;
    }

    return parseMoney(label.textContent);
  }

  function getMainProductPrice(scope) {
    const sale = scope.querySelector('.product__price--sale');
    if (sale) {
      const nodes = sale.querySelectorAll('*');
      for (const node of nodes) {
        if (node.querySelector && node.querySelector('s, del')) continue;
        const val = parseMoney(node.textContent);
        if (val !== null) return val;
      }
      const val = parseMoney(sale.textContent);
      if (val !== null) return val;
    }

    const main = scope.querySelector('.product__price');
    if (!main) return null;

    const nodes = main.querySelectorAll('*');
    for (const node of nodes) {
      if (node.querySelector && node.querySelector('s, del')) continue;
      const val = parseMoney(node.textContent);
      if (val !== null) return val;
    }

    return parseMoney(main.textContent);
  }

  function getCurrentPrice(scope) {
    const bundlePrice = getBundleTotalPrice(scope);
    if (bundlePrice !== null) return bundlePrice;

    const subscriptionPrice = getSubscriptionPrice(scope);
    if (subscriptionPrice !== null) return subscriptionPrice;

    return getMainProductPrice(scope);
  }

  function updateAllAtcButtons(scope) {
    const buttons = scope.querySelectorAll('[data-add-to-cart-text]');
    if (!buttons.length) return;

    const price = getCurrentPrice(scope);
    if (price === null) return;

    const qty = getQty(scope);
    const total = price * qty;
    const formatted = `$${total.toFixed(2)}`;

    buttons.forEach((btn) => {
      const priceEl = btn.querySelector('.btn__price');
      if (!priceEl) return;
      if (priceEl.textContent.trim() !== formatted) {
        priceEl.textContent = formatted;
      }
    });
  }

  function init() {
    const productSection =
      document.querySelector('[data-section-type="product"]') ||
      document.querySelector('product-form')?.closest('[data-section-type]') ||
      document.querySelector('product-form')?.closest('main');

    if (!productSection) return;

    function burst() {
      updateAllAtcButtons(productSection);
      setTimeout(() => updateAllAtcButtons(productSection), 50);
      setTimeout(() => updateAllAtcButtons(productSection), 150);
      setTimeout(() => updateAllAtcButtons(productSection), 400);
      setTimeout(() => updateAllAtcButtons(productSection), 800);
    }

    document.addEventListener('change', burst);
    document.addEventListener('click', burst);

    const observer = new MutationObserver(() => {
      updateAllAtcButtons(productSection);
    });

    observer.observe(productSection, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });

    burst();
  }

  document.addEventListener('DOMContentLoaded', init);
})();